export const SERVICE_CODE = 'VEHICLE' + '_TYPE' + '_SERVICE';
